import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef, useState } from 'react';
import { ChipsInput } from './ChipsInput.js';
import '@hh.ru/magritte-common-use-multiple-refs';
import '@hh.ru/magritte-ui-breakpoint';
import '@hh.ru/magritte-ui-chips-trigger';
import '@hh.ru/magritte-ui-input';
import '@hh.ru/magritte-ui-select';
import '@hh.ru/magritte-ui-suggest';

const DEFAULT_STATE = {
    value: '',
    chips: [],
};
const UncontrolledChipsInputComponent = ({ state: defaultState = DEFAULT_STATE, onChange, name, ...restProps }, ref) => {
    const [state, setState] = useState({ ...defaultState });
    return (jsxs(Fragment, { children: [jsx(ChipsInput, { ...restProps, state: state, onChange: (newState) => {
                    setState(newState);
                    onChange?.(newState);
                }, ref: ref }), state.chips.map((chip) => (jsx("input", { type: "hidden", name: name, value: chip.value }, chip.value)))] }));
};
const UncontrolledChipsInput = forwardRef(UncontrolledChipsInputComponent);
UncontrolledChipsInput.displayName = 'UncontrolledChipsInput';

export { UncontrolledChipsInput };
//# sourceMappingURL=UncontrolledChipsInput.js.map
